/* app/js/src/components/topHeader/clock/clock.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  background-color: #141b22;
  width: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  color: #ffffff;
}
div span {
  font-size: 1.2em;
  line-height: 1em;
  font-weight: 300;
  width: 100%;
  text-align: center;
}
div small {
  font-size: 0.8em;
  margin-top: 5px;
  color: #879baf;
  text-align: center;
}
div span,
div small {
  display: block;
}
/*# sourceMappingURL=clock.component.css.map */
